var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultar-empresa-list px-4"},[_c('div',{staticClass:"table-container"},[_c('b-table',{attrs:{"id":"consultar-empresa-temp","striped":"","responsive":"","items":_vm.rows,"fields":_vm.headerFields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }